// extracted by mini-css-extract-plugin
module.exports = {"container":"Preferences_container__HE1Tl","section":"Preferences_section__6ALkx","title":"Preferences_title__02ARj","success":"Preferences_success__5D9kD"};